import { ColDef, GridReadyEvent, CellFocusedEvent, SelectionChangedEvent } from 'ag-grid';
import { StateHandlerMap } from 'recompose';
import * as PropTypes from 'prop-types';
import { State, GridLayoutType } from './state';

export interface GridProps {
  gridLayout: GridLayoutType;
  rowHeight?: number;
  rowId: string;
  selectedRow?: string;
  columns?: ColDef[];
  rows?: object[];
  enableFilter?: boolean;
  editRowId?: number;
  onSelectRow?: (rowId: string) => void;
  onDeleteRow?: (rowId: number) => void;
  onEditRow?: (rowId: number | null) => void;
  onEditCell?: (rowId: number, cell: string, value: object) => void;
}

interface Node {
  id: number;
}

export interface CellProps {
  value: number;
  context: GridProps;
  colDef: ColDef;
  oldValue: object;
  newValue: object;
  node: Node;
}

export const propTypes = {
  columns: PropTypes.array,
  selectedRow: PropTypes.string,
  rows: PropTypes.array,
  editRowId: PropTypes.number,
  onSelectRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onEditCell: PropTypes.func
};

export type StateHandlerProps = StateHandlerMap<State> & {};

export type HandlerProps = {
  onGridReady: (event: GridReadyEvent) => void;
  onSelectionChanged: (event: SelectionChangedEvent) => void;
  onCellFocused: (event: CellFocusedEvent) => void;
};

export type EnhancedProps =
  GridProps &
  HandlerProps &
  State &
  StateHandlerProps;


// WEBPACK FOOTER //
// ./src/components/user-grid/props.ts